/** "2026-10-09T17:40:00-03:00" → "09/10/2026 às 17:40" (fuso de Brasília). */
export function dataHora(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const p = new Intl.DateTimeFormat("pt-BR", {
    timeZone: "America/Sao_Paulo",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
    .formatToParts(d)
    .reduce((a, x) => ({ ...a, [x.type]: x.value }), {});
  const dia = `${p.day}/${p.month}/${p.year}`;
  // Entradas antigas não têm hora gravada: mostra só a data em vez de 00:00.
  if (p.hour === "00" && p.minute === "00") return dia;
  return `${dia} às ${p.hour}:${p.minute}`;
}
